'use client'

import { useMemo } from 'react'
import Image from 'next/image'

import { Button, Heading, Paragraph } from '@graftcode/design-system'

import fallbackImage from '@common/core/assets/images/projects-fallback.png'

import { getNavigationUrls } from '../../config/navigation'

import type { NoProjectsFallbackProps } from './NoProjectsFallback.types'

import styles from './NoProjectsFallback.module.scss'

export function NoProjectsFallback({
  title,
  description,
  createButtonLabel,
  quickstartButtonLabel,
  onCreateProjectClick,
}: NoProjectsFallbackProps) {
  const quickstartUrl = useMemo(() => {
    const { academy } = getNavigationUrls()
    return `${academy}/quick-start`
  }, [])

  const handleQuickstartClick = () => {
    window.open(quickstartUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.illustration}>
        <Image
          priority
          width={160}
          height={160}
          quality={100}
          src={fallbackImage}
          alt="Start building with Graftcode"
        />
      </div>

      <div className={styles.content}>
        <Heading type="h4" className={styles.title}>
          {title}
        </Heading>
        <Paragraph size="sm" className={styles.description}>
          {description}
        </Paragraph>

        <div className={styles.actions}>
          <Button size="l" variant="primary" onClick={onCreateProjectClick}>
            {createButtonLabel}
          </Button>
          <Button size="l" variant="secondary" onClick={handleQuickstartClick}>
            {quickstartButtonLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}
